import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-067521f8")

_pushScopeId("data-v-067521f8")
const _hoisted_1 = {
  key: 1,
  class: "radio-circle cp-icon-radio-unchecked"
}
const _hoisted_2 = {
  key: 2,
  class: "label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: [[_ctx.disabled ? 'radio-disable' : ''], "form-radio-input"],
    tabindex: "0"
  }, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectRadio && _ctx.selectRadio(...args))),
      class: "flex items-center"
    }, [
      (_ctx.modelValue === _ctx.value)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["radio-circle cp-icon-radio-checked checked", _ctx.disabled ? 'radio-disable' : `${_ctx.color}`]
          }, null, 2))
        : (_openBlock(), _createBlock("span", _hoisted_1)),
      (_ctx.label)
        ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
})